import { z } from 'zod';
import { OnboardingState } from '@wix/ambassador-velo-github-v1-github-onboarding-status/types';

export const createAppSchema = z.object({
  app: z.object({ id: z.string() }),
});

const GitHubRepositorySchema = z
  .object({
    id: z.string(),
    repositoryName: z.string(),
    htmlUrl: z.string(),
    cloneUrl: z.string(),
  })
  .passthrough();

const gitHubDisabledSchema = z
  .object({
    onboardingState: z.literal(OnboardingState.GITHUB_DISABLED),
  })
  .passthrough();

const gitHubRepositoryCreatedSchema = z
  .object({
    onboardingState: z.literal(OnboardingState.GITHUB_REPOSITORY_CREATED),
    gitHubRepositoryCreated: z
      .object({
        repository: GitHubRepositorySchema,
      })
      .passthrough(),
  })
  .passthrough();

const gitHubEnabledSchema = z
  .object({
    onboardingState: z.literal(OnboardingState.GITHUB_ENABLED),
    gitHubEnabled: z
      .object({
        repository: GitHubRepositorySchema,
      })
      .passthrough(),
  })
  .passthrough();

const gitHubOnboardingStatusSchema = z.discriminatedUnion('onboardingState', [
  gitHubDisabledSchema,
  gitHubRepositoryCreatedSchema,
  gitHubEnabledSchema,
]);

export const gitHubOnboardingStatusResponseSchema = z
  .object({
    gitHubOnboardingStatus: gitHubOnboardingStatusSchema,
  })
  .passthrough();

export const listFilesSchema = z.object({
  files: z.array(
    z.object({
      path: z.string(),
      content: z.string(),
    })
  ),
  directories: z.array(
    z.object({
      path: z.string(),
    })
  ),
});

export const deployAppSchema = z.object({
  deploymentInfo: z.object({
    deploymentId: z.string().uuid(),
    deploymentUrl: z.string().url(),
    deploymentShortUrl: z.string().url().optional(),
    isPublishPipelineDeployment: z.boolean(),
  }),
});

export const resolveNpmDependenciesSchema = z.object({
  jobId: z.string(),
});

export const getResolveNpmDependenciesResultSchema = z.object({
  result: z.object({
    npmDependenciesLockFile: z.string().url(),
  }),
});

export const getWixLockFileSchema = z.string();
